import { PERCENTAGE_MAX } from "@/constants/percentage.constants";
import { Speaker } from "@/states/call/speakers/speakers.utility.decl";

export function getLeftPercentage(startTime: number, length: number) {
  if (length === 0) {
    return 0;
  }
  return (startTime * PERCENTAGE_MAX) / length;
}

export type GetWidthPercentageOptions = {
  end: number;
  length: number;
};

export function getWidthPercentage(
  start: number,
  { end, length }: GetWidthPercentageOptions
) {
  if (length === 0) {
    return 0;
  }
  return ((end - start) * PERCENTAGE_MAX) / length;
}

// We are checking if it's a number since 0 is also a valid option
export const getColor = (speaker: Speaker | undefined) =>
  speaker && Number.isInteger(speaker?.agentID) ? "primary" : "informative";
